import { Shield, PlayCircle, ArrowRight, Star } from 'lucide-react';

export function GlobePvtPromo() {
  return (
    <div className="bg-emerald-700 rounded-2xl overflow-hidden">
      <div className="p-5 sm:p-6">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-5">
          <div className="flex items-start gap-4 flex-1">
            <div className="flex-shrink-0">
              <div className="w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center">
                <Shield className="w-6 h-6 text-white" />
              </div>
            </div>

            <div className="flex-1">
              <div className="flex items-center gap-2 mb-1.5">
                <h3 className="text-lg font-bold text-white">
                  Assurance Globe PVT
                </h3>
                <span className="inline-flex items-center px-2 py-0.5 bg-white/15 rounded-md text-[11px] font-medium text-white">
                  Recommande
                </span>
              </div>
              <div className="flex items-center gap-2 mb-1.5">
                <div className="flex items-center gap-0.5">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-3.5 h-3.5 fill-yellow-300 text-yellow-300" />
                  ))}
                </div>
                <span className="text-xs text-emerald-200">4.7/5</span>
              </div>
              <p className="text-sm text-emerald-100 leading-relaxed">
                L'assurance sante de reference pour les Pvtistes
                <span className="hidden sm:inline"> -- recommandee par pvtistes.net</span>
              </p>
            </div>
          </div>

          <div className="flex items-center gap-2.5 flex-shrink-0 w-full md:w-auto">
            <a
              href="https://www.youtube.com/watch?v=dEv0Bs2jviY"
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 md:flex-initial inline-flex items-center justify-center gap-2 px-4 py-2.5 bg-white/10 hover:bg-white/15 text-white rounded-xl transition-colors text-sm font-medium"
            >
              <PlayCircle className="w-4 h-4" />
              <span>Video</span>
            </a>
            <a
              href="https://www.acs-ami.com/fr/part/pvtistes/globe-pvt/?part=pvtistes&utm_source=pvtistes-pwa&utm_medium=aff-link&utm_campaign=gp-pvt-pwa"
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 md:flex-initial inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-white text-emerald-700 rounded-xl font-semibold transition-colors hover:bg-emerald-50 text-sm"
            >
              <span>Souscrire</span>
              <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
